export default __webpack_public_path__ + "static/assets/med_pill_round_out_L0_solid_x_01_f.f598c68e.png";